import { IToken } from "@types";
import { client } from "./client";
import { settingsStore } from "../settings/store";

interface LoginParams {
  user_id: string;
  pw: string;
}

export const login = async (params: LoginParams): Promise<IToken> => {
  try {
    const response = await client.post("/signin", params);
    console.log(response);
    const { access_token, refresh_token, user } = response.data;

    const { pw, ...userWithoutPw } = user;
    localStorage.setItem("userInfo", JSON.stringify(userWithoutPw));
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("refresh_token", refresh_token);
    void settingsStore.reloadUser(); // 로그인한 사용자의 설정(테마 등) 반영
    return { access_token, refresh_token };
  } catch (error: any) {
    throw error; // response(status)를 그대로 넘겨야 LoginForm에서 401 구분 가능
  }
};

export const signup = async (params: { user_id: string; pw: string; name: string }) => {
  const response = await client.post("/signup", params);
  return response.data;
};

export const getHissoAddress = async () => {
  try {
    const response = await client.get("/hisso-address");
    return response.data;
  } catch (error) {
    console.error("getHissoAddress error => ", error);
    throw error;
  }
};

export const hissoLogin = async (token: string, type: string) => {
  try {
    const response = await client.post("/hisso-login", {
      token,
      type,
    });
    return response.data;
  } catch (error) {
    console.error("hissoLogin error => ", error);
    throw error;
  }
};

export const verifyAndLinkHissoAccount = async (
  login_id: string,
  pw: string,
  hissoUser: any,
) => {
  try {
    const response = await client.post("/hisso-link", {
      login_id,
      pw,
      hissoUser,
    });
    return response.data;
  } catch (error) {
    console.error("verifyAndLinkHissoAccount error => ", error);
    throw error;
  }
};
